export enum EUserRole {
  Admin = 'Admin',
  Worker = 'Worker'
}
